/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import DataConnector from 'connect/DataConnector';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ProtocolHistoryPanelState} from 'FileStates';
import CloneModal from 'folder-items/CloneModal';
// @ts-expect-error
import EditorActions from 'notebook/protocols/actions/EditorActions';
import ProtocolTabState from 'notebook/protocols/backbone/tabs/ProtocolTabState';
import EditorStore from 'notebook/protocols/stores/EditorStore';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';
import HistoryPanelComponent from 'toolbar/shared/HistoryPanelComponent';
import runModal from 'ui-library/runModal';

class ProtocolHistoryPanelConnector extends DataConnector<Props, EnhancedProps> {
  override props: any;
  override shouldSubscribeToRedux = false;
  override stores = [EditorStore];

  enhanceProps(): EnhancedProps {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getVersionState' does not exist on type ... Remove this comment to see the full error message
    return {versionState: EditorStore.getVersionState(this.props.id)};
  }
}

interface Props {
  id: string;
  activate: (...args: Array<any>) => any;
  folderId: string;
  name: string;
  permissions?: any;
}

interface EnhancedProps {
  versionState?: any;
}

class ProtocolHistoryPanel extends React.Component<Props & EnhancedProps> {
  override render(): JSX.Element {
    return (
      <HistoryPanelComponent
        openVersion={this.openVersion}
        resetToVersion={this.resetToVersion}
        cloneFromVersion={this.cloneFromVersion}
        versions={this.props.versionState.versions}
        openVersionId={this.props.versionState.openVersionId}
        isLatest={this.props.versionState.isLatest}
        unsaved={this.props.versionState.unsaved}
        parent={this.props.versionState.parent}
        hasParent={this.props.versionState.hasParent}
        permissions={this.props.permissions}
      />
    );
  }

  openVersion = (versionId: any): void => {
    this.props.activate();
    EditorActions.loadVersion(this.props.id, versionId);
  };

  resetToVersion = (): void => {
    EditorActions.resetToOpenVersion(this.props.id);
  };

  cloneFromVersion = (): void => {
    runModal(CloneModal, {
      modelType: ModelTypeConstants.PROTOCOL,
      id: this.props.id,
      versionId: this.props.versionState.openVersionId,
      initialName: `${this.props.name} (new)`,
      initialFolderId: this.props.folderId,
    });
  };
}

const ConnectedProtocolHistoryPanel = ProtocolHistoryPanelConnector.connect(ProtocolHistoryPanel);

class ProtocolHistoryPanelView extends ReactPanelBaseView<ProtocolHistoryPanelState, any> {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
  activate() {
    return this.model.fileState().findTab(ProtocolTabState).set({active: true});
  }

  getSubpanels(): Array<Subpanel> {
    return [
      {
        ...getTabAndPanelIds('history'),
        title: 'History',
        component: (
          <ConnectedProtocolHistoryPanel
            id={this.model.id}
            activate={this.activate.bind(this)}
            name={this.model.name()}
            folderId={this.model.folder().api_identifier}
            permissions={this.model.permissions()}
          />
        ),
      },
    ];
  }
}

export default ProtocolHistoryPanelView;
